export default __webpack_public_path__ + "static/media/3d-objects.af7a1997.jpeg";